var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Location',{attrs:{"lat":_vm.lat,"lng":_vm.lng}}),_c('Map',{on:{"latLng":_vm.onLatLng}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }